module.exports = __webpack_public_path__ + "img/wireframe.dd533aa6.png";